import React from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  FormGroup,
  Label,
  Input,
  Button,
  Table,
  Spinner,
  Alert
} from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import saveFile from "save-file";
import moment from "moment";
import { APIURL } from "../../config/config";
import {connect} from "react-redux";
import Loading from "../Loading";

class ProfitLossReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Date filters
      date_start: new Date(),
      date_end: new Date(),

      // Branch filter
      branches: [],
      selectedBranches: [],

      // Manual input fields
      service_revenue: "",
      other_expenses: "",

      // Report data
      reportData: null,

      // UI states
      isLoading: false,
      error: null,

      // Auth token
      token: localStorage.getItem("token")
    };
  }

  componentDidMount() {
    this.fetchBranches();
    // Auto-load today's report
    this.handleSearch();
  }

  fetchBranches = async () => {
    try {
      const response = await axios.get(
        APIURL + "/branch",
        {
          headers: {
            Authorization: this.state.token,
          },
        }
      );

      if (response.data && response.data.length > 0) {
        const branches = response.data.map(branch => ({
          value: branch.branch_id,
          label: branch.branch_name,
          ...branch
        }));
        this.setState({ branches });
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  handleSearch = async () => {
    this.setState({ isLoading: true, error: null });

    try {
      const branchIds = this.state.selectedBranches.map(branch => branch.value);

      const response = await axios.post(
        APIURL + "/report/profitloss",
        {
          start_date: moment(this.state.date_start).format("YYYY-MM-DD"),
          end_date: moment(this.state.date_end).format("YYYY-MM-DD"),
          branch_ids: branchIds
        },
        {
          headers: {
            Authorization: this.state.token,
          },
        }
      );

      if (response.data && response.data.success) {
        this.setState({ reportData: response.data.data });
      } else {
        this.setState({ error: "ไม่สามารถดึงข้อมูลรายงานได้" });
      }
    } catch (error) {
      console.error("Error fetching profit/loss report:", error);
      this.setState({
        error: error.response && error.response.data ? error.response.data.message : "เกิดข้อผิดพลาดในการดึงข้อมูล"
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  handleExportExcel = async () => {
    this.setState({ isLoading: true });

    try {
      const branchIds = this.state.selectedBranches.map(branch => branch.value);
      const branchNames = this.state.selectedBranches.length > 0
        ? this.state.selectedBranches.map(b => b.label).join(", ")
        : "ทุกสาขา";

      const response = await axios.post(
        APIURL + "/report/profitlossexcel",
        {
          start_date: moment(this.state.date_start).format("YYYY-MM-DD"),
          end_date: moment(this.state.date_end).format("YYYY-MM-DD"),
          branch_ids: branchIds,
          branch_names: branchNames,
          service_revenue: this.state.service_revenue || 0,
          other_expenses: this.state.other_expenses || 0
        },
        {
          headers: {
            Authorization: this.state.token,
          },
          responseType: "arraybuffer"
        }
      );

      // Create filename with timestamp
      const currentDate = moment().format("YYYY-MM-DD");
      const currentTime = moment().format("HH-mm-ss");
      const filename = `รายงานงบกำไร-ขาดทุน_${currentDate}_${currentTime}.xlsx`;

      // Save file
      saveFile(new Blob([response.data]), filename);
    } catch (error) {
      console.error("Error exporting Excel:", error);
      alert("เกิดข้อผิดพลาดในการส่งออก Excel: " + (error.response && error.response.data ? error.response.data.message : error.message));
    } finally {
      this.setState({ isLoading: false });
    }
  };

  formatNumber = (num) => {
    if (!num && num !== 0) return "-";
    return new Intl.NumberFormat("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  };

  render() {
    const {
      date_start,
      date_end,
      branches,
      selectedBranches,
      service_revenue,
      other_expenses,
      reportData,
      isLoading,
      error
    } = this.state;

    // Calculate totals with manual inputs
    const totalRevenueWithService = reportData
      ? (reportData.revenue.total_revenue || 0) + (parseFloat(service_revenue) || 0)
      : 0;

    const totalExpensesWithOther = reportData
      ? (reportData.expenses.total_expenses || 0) + (parseFloat(other_expenses) || 0)
      : 0;

    const netProfitFinal = totalRevenueWithService - totalExpensesWithOther;

    // Debug logging
    /*if (reportData) {
      console.log('Frontend Debug - repair_costs:', reportData.expenses.repair_costs);
      console.log('Frontend Debug - expenses:', reportData.expenses);
    }*/

    return (
        <div className="row" style={styles.overflowY}>
        <Loading isLoading={this.state.isLoading} />

          <div className="card-block">
            <div className="card card-accent-primary">
              <div className="card-header">
                <div className="row">
                  <div className="col-12 mb-2">
                    <strong className="text-title"> รายงานงบกำไร-ขาดทุน </strong>
                  </div>
                </div>

                <div className="row col-12 mt-2">
                  <div className="mt-1">วันที่เริ่มต้น</div>
                  <div className="form-group col-1" style={{ width: 200}}>
                    <DatePicker
                        id="date_start"
                        className="form-control"
                        selected={date_start}
                        onChange={(date) => this.setState({ date_start: date })}
                        dateFormat="dd/MM/yyyy"
                    />
                  </div>
                  <div className="mt-1 ml-2">วันที่สิ้นสุด &nbsp;</div>
                  <div className="col-1" style={{ width: 200 }}>
                    <DatePicker
                        id="date_end"
                        className="form-control"
                        selected={date_end}
                        onChange={(date) => this.setState({ date_end: date })}
                        dateFormat="dd/MM/yyyy"
                    />
                  </div>
                  <div className="form-group" style={{ width: 250 }}>
                    <Select
                        styles={customStyles}
                        id="branches"
                        value={selectedBranches}
                        onChange={(selectedBranches) => this.setState({ selectedBranches })}
                        options={branches}
                        isMulti
                        isClearable
                        placeholder="เลือกสาขา"
                    />
                  </div>
                  <div className="d-flex ml-3 mr-2 mt-2">
                    <Button
                        color="primary"
                        onClick={this.handleSearch}
                        disabled={isLoading}
                        style={{ marginRight: '10px' }}
                    >
                      {isLoading ? <Spinner size="sm" /> : "ค้นหา"}
                    </Button>
                  </div>
                  <div className="d-flex mt-2">
                    <Button
                        color="success"
                        onClick={this.handleExportExcel}
                        disabled={isLoading || !reportData}
                    >
                      {isLoading ? <Spinner size="sm" /> : "Excel"}
                    </Button>
                  </div>
                </div>
                <small>
                  * สาขา (เว้นว่างไว้ = เลือกทุกสาขา)
                </small>
              </div>

              <div className="card-block">
                <div className="row">
                  <div className="col-12">
                    <h6><strong className="mb-3">สรุปผลการดำเนินงาน</strong></h6>
                    {/* Manual Input Fields */}
                    <div className="row col-12" style={{ marginTop: '20px' }}>
                      <Col xs={12} sm={6} md={3}>
                        <FormGroup>
                          <Label for="service_revenue">รายได้จากบริการซ่อมบำรุง (บาท)</Label>
                          <Input
                              type="number"
                              id="service_revenue"
                              value={service_revenue}
                              onChange={(e) => this.setState({ service_revenue: e.target.value })}
                              placeholder="0.00"
                              step="0.01"
                          />
                          <small>* ค่านี้จะแสดงในไฟล์ Excel เท่านั้น</small>
                        </FormGroup>
                      </Col>

                      <Col xs={12} sm={6} md={3}>
                        <FormGroup>
                          <Label for="other_expenses">ค่าใช้จ่ายอื่นๆ (บาท)</Label>
                          <Input
                              type="number"
                              id="other_expenses"
                              value={other_expenses}
                              onChange={(e) => this.setState({ other_expenses: e.target.value })}
                              placeholder="0.00"
                              step="0.01"
                          />
                          <small>* ค่านี้จะแสดงในไฟล์ Excel เท่านั้น</small>
                        </FormGroup>
                      </Col>
                    </div>

                    {/* Error Message */}
                    {error && (
                        <Alert color="danger" style={{ marginTop: '20px' }}>
                          {error}
                        </Alert>
                    )}

                    {reportData && !isLoading && (
                    <table className="striped bordered responsive" border={0} style={{ border: 0, lineHeight:2}}>
                      <tbody>
                      {/* Revenue Section */}
                      <tr>
                        <td colSpan="6" className="font-weight-bold bg-light">1. รายได้ (Revenue)</td>
                      </tr>
                      <tr>
                        <td colSpan="5" style={{paddingLeft:'30px'}}>1.1 รายได้จากการขายรถมือสอง <br/>
                        <span style={{fontSize: '12px'}}>ราคาขายจริง (ไม่รวมค่าซ่อมและค่าใช้จ่ายอื่นๆของรถ)</span>
                        </td>
                        <td className="text-right">{this.formatNumber(reportData.revenue.car_sales_revenue)}</td>
                      </tr>
                      <tr>
                        <td colSpan="5" style={{ paddingLeft: '30px' }}>
                          1.2 รายได้จากบริการซ่อมบำรุง
                          {service_revenue && (
                              <span className="text-muted ml-2">
                            (+{this.formatNumber(parseFloat(service_revenue) || 0)})
                          </span>
                          )}
                        </td>
                        <td className="text-right">{this.formatNumber(parseFloat(service_revenue) || 0)}</td>
                      </tr>
                      <tr>
                        <td colSpan="5" style={{ paddingLeft: '30px' }}>1.3 ค่าคอมมิชชั่นจากไฟแนนซ์</td>
                        <td className="text-right">{this.formatNumber(reportData.revenue.finance_commission)}</td>
                      </tr>
                      <tr>
                        <td colSpan="5" style={{ paddingLeft: '30px' }}>1.4 รายได้อื่นๆ</td>
                        <td className="text-right">{this.formatNumber(reportData.revenue.other_income)}</td>
                      </tr>
                      <tr className="font-weight-bold text-primary bg-light">
                        <td colSpan="5">รวมรายได้</td>
                        <td className="text-right">{this.formatNumber(totalRevenueWithService)}</td>
                      </tr>

                      <tr className="font-weight-bold bg-light">
                        <td colSpan="5"><hr/></td>
                        <td className="text-right"><hr/></td>
                      </tr>
                      {/* Car Expenses Section */}
                      <tr>
                        <td colSpan="6" className="font-weight-bold bg-light">
                          2. ค่าใช้จ่าย (Expenses)
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5" style={{ paddingLeft: '30px'}}>2.1 รวมต้นทุนซื้อรถ<br/>
                        <span style={{fontSize: '12px'}}>ราคาซื้อเข้า</span></td>
                        <td className="text-right">{this.formatNumber(reportData.expenses.car_purchase_cost)}</td>
                      </tr>
                      <tr>
                        <td colSpan="5" style={{ paddingLeft: '30px' }}>
                          2.2 ค่าใช้จ่ายซ่อมบำรุงและคจช.ทั้งหมดเกี่ยวกับตัวรถ
                        <br/>
                        <span style={{fontSize: '12px'}}>เฉพาะรถที่ขายแล้ว</span></td>
                        <td className="text-right">
                          {this.formatNumber(reportData.expenses.repair_costs)}
                        </td>
                      </tr>
                      <tr className="font-weight-bold text-warning bg-light">
                        <td colSpan="5">รวมค่าใช้จ่ายซื้อรถ/ซ่อม</td>
                        <td className="text-right">{this.formatNumber(reportData.expenses.total_car_expenses)}</td>
                      </tr>

                      <tr className="font-weight-bold bg-light">
                        <td colSpan="5"><hr/></td>
                        <td className="text-right"><hr/></td>
                      </tr>
                      {/* Company Expenses Section */}
                      <tr>
                        <td colSpan="6" className="font-weight-bold bg-light">
                          3. ค่าใช้จ่ายบริษัท
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="5" style={{ paddingLeft: '30px' }}>3.1 ค่าใช้จ่ายเบ็ดเตล็ด</td>
                        <td className="text-right">{this.formatNumber(reportData.expenses.company_expenses.miscellaneous)}</td>
                      </tr>
                      <tr>
                        <td colSpan="5" style={{ paddingLeft: '30px' }}>3.2 เงินเดือนพนักงานและค่าจ้าง <br/>
                        <span style={{fontSize: '12px'}}>หมวดค่าใช้จ่ายเงินเดือนพนักงาน</span></td>
                        <td className="text-right">{this.formatNumber(reportData.expenses.company_expenses.salaries)}</td>
                      </tr>
                      <tr>
                        <td colSpan="5" style={{ paddingLeft: '30px' }}>3.3 ค่าใช้จ่ายส่วนตัวกรรมการ<br/>
                        <span style={{fontSize: '12px'}}>หมวดค่าใช้จ่ายส่วนตัว</span></td>
                        <td className="text-right">{this.formatNumber(reportData.expenses.company_expenses.board_expenses)}</td>
                      </tr>
                      <tr>
                        <td colSpan="5" style={{ paddingLeft: '30px' }}>3.4 ดอกเบี้ยเงินกู้ของบริษัท<br/>
                        <span style={{fontSize: '12px'}}>หมวดค่าใช้จ่ายดอกเบี้ย</span></td>
                        <td className="text-right">{this.formatNumber(reportData.expenses.company_expenses.interest_expenses)}</td>
                      </tr>
                      <tr>
                        <td colSpan="5" style={{ paddingLeft: '30px' }}>3.5 ค่าเช่าและผ่อนชำระทรัพย์สิน (บ้าน/รถ/ที่ดิน) <br/>
                        <span style={{fontSize: '12px'}}>หมวดค่าใช้จ่ายค่าเช่าและผ่อน</span></td>
                        <td className="text-right">{this.formatNumber(reportData.expenses.company_expenses.rental_installment || 0)}</td>
                      </tr>
                      <tr>
                        <td colSpan="5" style={{ paddingLeft: '30px' }}>
                          3.6 อื่นๆ
                          {other_expenses && (
                              <span className="text-muted ml-2">
                            (+{this.formatNumber(parseFloat(other_expenses) || 0)})
                          </span>
                          )}
                        </td>
                        <td className="text-right">{this.formatNumber(parseFloat(other_expenses) || 0)}</td>
                      </tr>
                      <tr className="font-weight-bold bg-light text-warning ">
                        <td colSpan="5" >รวมค่าใช้จ่ายทั่วไป</td>
                        <td className="text-right">
                          {this.formatNumber(
                              (reportData.expenses.company_expenses.total_company_expenses || 0) +
                              (parseFloat(other_expenses) || 0)
                          )}
                        </td>
                      </tr>

                      {/* Net Profit */}
                      <tr className={`font-weight-bold ${netProfitFinal >= 0 ? 'text-success' : 'text-danger'}`}>
                        <td colSpan="5" style={{ fontSize: '17px' }}>กำไรสุทธิ</td>
                        <td className="text-right" style={{ fontSize: '17px' }}>
                          {this.formatNumber(netProfitFinal)}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                      )}
                    <small className="text-muted">
                      * หมายเหตุ: รายการที่มีเครื่องหมาย (+) คือค่าที่กรอกเพิ่มเติมจากหน้าฟอร์ม ซึ่งจะรวมในการส่งออก Excel
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    );
  }
}
const styles = {
  overflowY: {
    overflow: "scroll",
  },
};

const customStyles = {
  control: (provided) => ({
    // class attribute : class=" css-i32vvf-control"
    ...provided,
    //background: "transparent",
    background: "white",
    display: "flex",
    flexWrap: "nowrap",
    borderRadius: 5,
    height: 0,
  }),
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(ProfitLossReport);